// extracted by mini-css-extract-plugin
export var orderSummary = "_py-0";
export var showMoreLessButton = "_py-1";